import React from 'react';
import { ClipboardCheck, Calendar, Clock, LayersIcon } from 'lucide-react';

const LoadingValue = () => (
  <span className="animate-pulse">
    <span className="h-8 w-16 bg-gray-200 rounded inline-block"></span>
  </span>
);

const getColorClasses = (color) => ({
  blue: { bg: "bg-blue-600", light: "bg-blue-50", text: "text-blue-600" },
  purple: { bg: "bg-purple-600", light: "bg-purple-50", text: "text-purple-600" },
  green: { bg: "bg-green-600", light: "bg-green-50", text: "text-green-600" },
  orange: { bg: "bg-orange-500", light: "bg-orange-50", text: "text-orange-500" },
  gray: { bg: "bg-gray-600", light: "bg-gray-50", text: "text-gray-600" }
}[color]);

const StatCard = ({ title, value, icon: Icon, color }) => (
  <div className="w-full">
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className={`h-1 ${getColorClasses(color).bg}`} />
      <div className="p-6">
        <div className="flex items-center justify-between">
          <div className={`p-3 rounded-lg ${getColorClasses(color).light}`}>
            <Icon className={`h-6 w-6 ${getColorClasses(color).text}`} />
          </div>
          <div className="text-2xl font-bold text-gray-800">
            {value}
          </div>
        </div>
        <div className="mt-4 text-sm font-medium text-gray-600">{title}</div>
      </div>
    </div>
  </div>
);

const StatsCards = ({ isLoading, surveyStats }) => {
  // Calculate total from completed + pending
  const totalSurveys = isLoading ? 
    <LoadingValue /> : 
    (surveyStats.totalCompleted + surveyStats.totalPending).toLocaleString();

  return (
    <div className="w-full pt-10 pb-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 px-4 mx-auto max-w-6xl">
        <StatCard
          title="Completed Surveys"
          value={isLoading ? <LoadingValue /> : surveyStats.totalCompleted.toLocaleString()}
          icon={ClipboardCheck}
          color="green"
        />
        
        <StatCard
          title="Pending Surveys"
          value={isLoading ? <LoadingValue /> : surveyStats.totalPending.toLocaleString()}
          icon={Clock}
          color="blue"
        />
        
        <StatCard
          title="Total Surveys"
          value={totalSurveys}
          icon={LayersIcon}
          color="gray"
        />
        
        <StatCard
          title="Monthly Survey Count"
          value={isLoading ? <LoadingValue /> : surveyStats.monthlyCount.toLocaleString()}
          icon={Calendar}
          color="orange"
        />
      </div>
    </div>
  );
};

export default StatsCards;